import { styled } from 'styled-components'
import { Button } from '@mui/material'

export const StyledQuestionButton = styled(Button)`
font-size: 12px;
padding: 8px;
display: flex;
flex-direction: column;
align-items: start;
text-align: left;
background-color: #FAFAFA !important;
border: 1px solid #E0E0E0 !important;
color: black !important;
`

export const StyledTextTitle = styled.div`
  font-weight: bold;
  width: 100%;
  text-transform: none;
`

export const StyledTextQuestion = styled.div`
  font-weight: normal;
  width: 100%;
  text-transform: none;
`
